import { Input, InputGroup, InputLeftElement, Stack, Text, useEventListener, } from "@chakra-ui/react";
import React, { useCallback, useMemo, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useServices } from "../hooks/useServices";
import { LayoutItemFactory } from "../studioContext";
export const WidgetList = React.memo(({ widgets, isLocked, screenWidth, screenHeight, layoutItems }) => {
    const { layoutService } = useServices();
    const [searchbarValue, setSearchbarValue] = useState("");
    const [stackWidth, setStackWidth] = useState();
    const [stackNode, setStackNode] = useState();
    const stackRef = useCallback((node) => {
        var _a, _b;
        setStackNode(node);
        setStackWidth((_b = (_a = node === null || node === void 0 ? void 0 : node.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0);
    }, []);
    useEventListener("resize", () => {
        var _a, _b;
        setStackWidth((_b = (_a = stackNode === null || stackNode === void 0 ? void 0 : stackNode.getBoundingClientRect()) === null || _a === void 0 ? void 0 : _a.width) !== null && _b !== void 0 ? _b : 0);
    }, 
    // @ts-ignore
    window);
    const searchedWidgets = widgets.filter((widget) => {
        return JSON.stringify(Object.values(widget)).includes(searchbarValue);
    });
    return (React.createElement(Stack, { ref: stackRef, gap: 4, width: "100%", "data-testid": "lateral-menu-widgets-list-test-id" },
        React.createElement(InputGroup, null,
            React.createElement(InputLeftElement, { pointerEvents: "none", children: React.createElement(FiSearch, null) }),
            React.createElement(Input, { placeholder: "Rechercher un widget", value: searchbarValue, onChange: (e) => {
                    setSearchbarValue(e.currentTarget.value);
                } })),
        React.createElement(Widgets, { layoutService: layoutService, layoutItemsLength: layoutItems.length, stackWidth: stackWidth, widgets: searchbarValue === "" ? widgets : searchedWidgets, isLocked: isLocked, screenHeight: screenHeight, screenWidth: screenWidth })));
}, (prevProps, nextProps) => {
    if (prevProps.isLocked !== nextProps.isLocked)
        return false;
    return true;
});
const Widgets = ({ layoutService, layoutItemsLength, widgets, stackWidth, isLocked, screenWidth, screenHeight, }) => {
    const displayedWidgetPreviews = useMemo(() => widgets
        .filter((widget) => widget.name.toLowerCase() !== "text")
        .map((widget) => {
        if (widget.addWidgetPreview)
            return widget;
        const DefaultWidgetPreview = () => {
            return (React.createElement(Stack, { direction: "row", gap: 2, borderRadius: 6, p: 4, backgroundColor: "gray.100", alignItems: "center", cursor: "pointer", transition: "0.2s", sx: {
                    ":hover": {
                        backgroundColor: "gray.200",
                    },
                }, onClick: () => {
                    if (isLocked)
                        return;
                    const newWidget = LayoutItemFactory(widget, layoutItemsLength, screenWidth, screenHeight);
                    layoutService.addLayoutItem(newWidget);
                } },
                widget.icon,
                React.createElement(Text, { textAlign: "center" }, widget.name)));
        };
        return {
            ...widget,
            addWidgetPreview: [DefaultWidgetPreview],
        };
    })
        .map((widget) => {
        var _a;
        return ((_a = widget.addWidgetPreview) !== null && _a !== void 0 ? _a : []).map((Preview) => ({
            Preview,
            widget,
        }));
    })
        .flat(), [widgets]);
    return (React.createElement(Stack, { mt: "0 !important", gap: 2 }, displayedWidgetPreviews.map(({ Preview, widget }, previewIndex) => {
        return (React.createElement(Preview, { key: `widget-preview-$-${previewIndex}`, widgetWidth: stackWidth !== null && stackWidth !== void 0 ? stackWidth : 0, screenheight: screenHeight, onClick: (data) => {
                if (isLocked)
                    return;
                const newWidget = LayoutItemFactory(widget, layoutItemsLength, screenWidth, screenHeight, {
                    data,
                });
                layoutService.addLayoutItem(newWidget);
            }, cursor: "pointer", borderRadius: "6px", overflow: "hidden" }));
    })));
};
